<div class="ai-summary-box">
  <div class="summary-header">
    <div class="header-left">
      <cm-icon name="auto_awesome" size="md" class="ai-icon" aria-hidden="true" />
      <h2 class="summary-title">AI-generated Summary</h2>
    </div>
  </div>

  @if (hasError()) {
    <!-- Error State -->
    <div class="error-state">
      <cm-icon name="error" size="md" class="error-icon" aria-hidden="true" />
      <p class="error-message">{{ error() }}</p>
      <cm-button
        variant="flat"
        color="primary"
        (click)="handleRetry()"
        autId="retry-summary-button"
      >
        Retry
      </cm-button>
    </div>
  } @else if (loading()) {
    <!-- Loading State -->
    <div class="loading-state">
      <cm-spinner size="medium" />
      <p class="loading-message">Generating AI summary...</p>
    </div>
  } @else {
    <!-- Summary Content -->
    <div class="summary-content">
      @if (!isExpanded() && shouldTruncate()) {
        <p class="summary-text">
          {{ displayedSummary() }}
          <cm-button
            variant="basic"
            color="primary"
            class="read-toggle"
            (click)="toggleExpanded()"
            autId="read-toggle-expand"
          >
            {{ toggleLabel() }}
          </cm-button>
        </p>
      } @else {
        @for (section of parsedSections(); track section.title) {
          <div class="summary-section">
            @if (section.title) {
              <h3 class="section-title">{{ section.title }}</h3>
            }
            <p class="section-content">{{ section.content }}</p>
          </div>
        }

        @if (recentUpdates().length > 0) {
          <div class="recent-updates">
            <h3 class="section-title">RECENT UPDATES</h3>
            <ul class="updates-list">
              @for (update of recentUpdates(); track $index) {
                <li>{{ update }}</li>
              }
            </ul>
          </div>
        }

        @if (showToggle()) {
          <cm-button
            variant="basic"
            color="primary"
            class="read-toggle read-toggle-after"
            (click)="toggleExpanded()"
            autId="read-toggle-collapse"
          >
            {{ toggleLabel() }}
          </cm-button>
        }
      }
    </div>

<!-- Actions (always visible when there's content) -->
    @if (showActions()) {
      <div class="summary-actions">
        <cm-button
          variant="basic"
          color="primary"
          (click)="onCopy()"
          autId="copy-summary-button"
        >
          Copy
        </cm-button>
        <cm-button
          variant="basic"
          color="gray"
          (click)="onCancel()"
          autId="cancel-summary-button"
        >
          Cancel
        </cm-button>
      </div>
    }
  }
</div>
